import { z } from 'zod';

export const withCustomRefine = (base, refine) =>
    z.preprocess((input, ctx) => {
        base.safeParse(input);
        refine(input, ctx);
        return input;
    }, base);
